import { styled } from 'styled-components'

import { breakpoints } from '@src/constants/breakpoints'

export const BannerOverlay = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  background-color: ${({ theme }) => theme.colors.brandForeground};
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.15);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (min-width: ${breakpoints.tablet}px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`

export const BannerText = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.mainText};
  flex: 1;
  min-width: 0;
`

export const PolicyLine = styled.span`
  display: inline;

  @media (min-width: ${breakpoints.largeTablet}px) {
    display: block;
  }
`

export const CookiePolicyLink = styled.a`
  color: ${({ theme }) => theme.colors.brand};
  text-decoration: underline;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    opacity: 0.8;
  }
`

export const ButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: flex-end;
  flex-shrink: 0;

  button {
    min-width: 150px;
  }
`
